/* eslint-disable no-nested-ternary */
import $i18n from 'panda-i18n';
const defaultViewConfigStorageKey = `${location.hostname?.replace(/[^A-Za-z0-9]/gm, '')}_${location.pathname?.replace(/[^A-Za-z0-9]/gm, '')}`;
function getMaxSearchTagsLengthShowLimitInLine() {
    const { clientWidth } = document.documentElement;
    if (clientWidth > 1920) {
        return 4;
    }
    if (clientWidth > 1440) {
        return 3;
    }
    if (clientWidth > 1200) {
        return 2;
    }
    return clientWidth > 0 ? 1 : 3;
}
export const defaultPresetHabitSetting = {
    defaultViews: [
        {
            id: 'allData',
            name: $i18n.get({
                id: 'allDataLabel',
                dm: '全部数据',
            }),
            filter: {
                searchTags: [],
                filterSetting: {},
            },
        },
    ],
    defaultViewId: 'allData',
    searchPlaceholder: $i18n.get({
        id: 'allDataLabel',
        dm: '全部数据',
    }),
    viewConfigStorageKey: defaultViewConfigStorageKey?.length >= 44
        ? defaultViewConfigStorageKey.substring(0, 44)
        : defaultViewConfigStorageKey,
    extendSaveViewFormSchema: {},
};
export const hottagPrefix = 'cn.component.one-search';
export const viewNameLengthLimit = 14;
export const customViewsLengthLimit = 20;
export const defaultDateRange = function ($dI18n) {
    return [
        {
            label: $dI18n.get({
                id: 'TodayToNow',
                dm: $i18n.get({ id: 'TodayToNow', dm: '今天00:00:00到现在' }),
            }),
            value: $dI18n.get({
                id: 'TodayToNow',
                dm: $i18n.get({ id: 'TodayToNow', dm: '今天00:00:00到现在' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'YesterdayTo',
                dm: $i18n.get({ id: 'YesterdayTo', dm: '昨天00:00:00到23:59:59' }),
            }),
            value: $dI18n.get({
                id: 'YesterdayTo',
                dm: $i18n.get({ id: 'YesterdayTo', dm: '昨天00:00:00到23:59:59' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'ThisWeek',
                dm: $i18n.get({ id: 'ThisWeek', dm: '本周' }),
            }),
            value: $dI18n.get({
                id: 'ThisWeek',
                dm: $i18n.get({ id: 'ThisWeek', dm: '本周' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'ThisMonth',
                dm: $i18n.get({ id: 'ThisMonth', dm: '本月' }),
            }),
            value: $dI18n.get({
                id: 'ThisMonth',
                dm: $i18n.get({ id: 'ThisMonth', dm: '本月' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'ThisQuarter',
                dm: $i18n.get({ id: 'ThisQuarter', dm: '本季度' }),
            }),
            value: $dI18n.get({
                id: 'ThisQuarter',
                dm: $i18n.get({ id: 'ThisQuarter', dm: '本季度' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'LastHour',
                dm: $i18n.get({ id: 'LastHour', dm: '过去1小时' }),
            }),
            value: $dI18n.get({
                id: 'LastHour',
                dm: $i18n.get({ id: 'LastHour', dm: '过去1小时' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'LastHours',
                dm: $i18n.get({ id: 'LastHours', dm: '过去24小时' }),
            }),
            value: $dI18n.get({
                id: 'LastHours',
                dm: $i18n.get({ id: 'LastHours', dm: '过去24小时' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'PastWeek',
                dm: $i18n.get({ id: 'PastWeek', dm: '过去1周' }),
            }),
            value: $dI18n.get({
                id: 'PastWeek',
                dm: $i18n.get({ id: 'PastWeek', dm: '过去1周' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'LastMonth',
                dm: $i18n.get({ id: 'LastMonth', dm: '过去1个月' }),
            }),
            value: $dI18n.get({
                id: 'LastMonth',
                dm: $i18n.get({ id: 'LastMonth', dm: '过去1个月' }),
            }),
        },
        {
            label: $dI18n.get({
                id: 'LastMonths',
                dm: $i18n.get({ id: 'LastMonths', dm: '过去3个月' }),
            }),
            value: $dI18n.get({
                id: 'LastMonths',
                dm: $i18n.get({ id: 'LastMonths', dm: '过去3个月' }),
            }),
        },
    ];
};
var Env;
(function (Env) {
    Env["Prod"] = "prod";
    Env["Pre"] = "pre";
    Env["Local"] = "local";
})(Env || (Env = {}));
/** 地址映射 */
const HOST_CONFIG_MAP = {
    [Env.Local]: {
        host: `http://localhost.wapa.cainiao.com${location.port === '7800' ? ':7700' : `:${location.port}`}`,
    },
    [Env.Pre]: {
        host: 'https://pre-cn-x-gateway.cainiao.com',
    },
    [Env.Prod]: {
        host: 'https://cn-x-gateway.cainiao.com',
    },
};
/** 地址映射 */
const FLAMINGO_HOST_CONFIG_MAP = {
    [Env.Local]: {
        host: `https://pre-flamingo.cainiao-inc.com`,
    },
    [Env.Pre]: {
        host: 'https://pre-flamingo.cainiao-inc.com',
    },
    [Env.Prod]: {
        host: 'https://flamingo.cainiao-inc.com',
    },
};
// 搜索tag一行最多显示的个数，多于此数量则默认收起展示
export const maxSearchTagsLengthShowLimitInLine = getMaxSearchTagsLengthShowLimitInLine();
// 当前环境
const ENV_MODE = location.hostname.indexOf('localhost') !== -1
    ? Env.Local
    : location.hostname.indexOf('pre-') !== -1 ||
        location.hostname.indexOf('.test') !== -1 ||
        location.hostname.indexOf('daily-') !== -1 ||
        location.hostname.indexOf('dev.g') !== -1
        ? Env.Pre
        : Env.Prod;
export const getLowcodePageDetail = () => {
    return window.getCnLowcodeStoreItem ? window.getCnLowcodeStoreItem('page') || {} : {};
};
export const getLowcodePageUser = () => {
    return window.getCnLowcodeStoreItem ? window.getCnLowcodeStoreItem('user') || {} : {};
};
export const getCurrentAppInfo = () => {
    return window.getCnLowcodeStoreItem ? window.getCnLowcodeStoreItem('app') || {} : {};
};
// 内部调用的suggest api
export const defaultSuggestApi = `${HOST_CONFIG_MAP[ENV_MODE].host}/oneSearch_feedback/zs96tt/api/suggest`;
// 内部调用的翻译api
export const defaultFieldTransformApi = `${HOST_CONFIG_MAP[ENV_MODE].host}/oneSearch_feedback/zs96tt/api/languageTranslator`;
// 内部上报用户反馈的api
export const defaultFeedbackApi = `${HOST_CONFIG_MAP[ENV_MODE].host}/oneSearch_feedback/zs96tt/api/feedback`;
// 创建应用获取bizAccessKey
export const createAppGetBizAccessKey = `${FLAMINGO_HOST_CONFIG_MAP[ENV_MODE].host}/apis/oneSearch/v2/createAppFromCone`;
// 词典同步
export const syncConeDict = `${FLAMINGO_HOST_CONFIG_MAP[ENV_MODE].host}/apis/oneSearch/v2/dictSyncCone2OneSearch`;
// CNPD列表
export const findBusinessDomain = `/nextapi/businessDomain/find`;
